import { createFileRoute } from "@tanstack/react-router";
import { NewPool } from "../../../features/infrastructure/pool-new";

export const Route = createFileRoute("/_authed/$org/$project/pools/new")({ component: NewPoolPage });

function NewPoolPage() {
  const { org, project } = Route.useParams();
  return <NewPool scope={{ org, project }} />;
}
